import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'
import { PublicConsentType } from '@tm/types/db/tables'
import { useI18N } from '../../../hooks/useI18n'
import { ConsentText } from '../../question/PublicConsent'

export type ConsentFieldProps = {
  type: PublicConsentType
  value: boolean
  onChange: (value: boolean) => void
  privacyPolicyOrganization?: string
  privacyPolicyUrl?: string
  validationErrors?: string
  isPublicConsent?: boolean
}

const trustmaryPolicyUrl = 'https://trustmary.com/terms-summary-for-reviewers/'

export function ConsentField(props: ConsentFieldProps) {
  const { type, privacyPolicyOrganization, privacyPolicyUrl, value, onChange, validationErrors, isPublicConsent } =
    props
  const { t } = useI18N()

  if (type === 'default')
    return (
      <ConsentText
        label={t('publicConsent.v2.nonGdpr.label')}
        trustmaryPolicyUrl={trustmaryPolicyUrl}
        privacyPolicyOrganization={privacyPolicyOrganization || ''}
        privacyPolicyUrl={privacyPolicyUrl}
      />
    )

  // gdpr-compliant
  return (
    <FormControl error={!!validationErrors}>
      <FormControlLabel
        control={<Checkbox checked={value} onChange={() => onChange(!value)} />}
        label={
          <ConsentText
            // If consent field is public consent, show "I want to publis my comment", otherwise show "I have read privacy policy"
            label={isPublicConsent ? t('publicConsent.v2.gdpr.label') : t('publicConsent.v2.readPrivacyPolicy')}
            trustmaryPolicyUrl={trustmaryPolicyUrl}
            privacyPolicyOrganization={privacyPolicyOrganization || ''}
            privacyPolicyUrl={privacyPolicyUrl}
          />
        }
      />
      {!!validationErrors && (
        <Typography variant="caption" color="error">
          {validationErrors}
        </Typography>
      )}
    </FormControl>
  )
}
